/**
 * Main index file
 */

import BaseLayout from './site/BaseLayout';
import MenuSelector from './site/MenuSelector';

import AccordionBlock from './site/blocks/AccordionBlock';
import CarouselBannerBlock from './site/blocks/CarouselBannerBlock';

import { GallleryLightbox } from './site/modals/Lightbox';

// If sentry is active
if(window.Sentry && window.SENTRY_DSN) {

    // Initialise sentry with settings
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration()
        ],
        tracesSampleRate: 0,
        environment : window.APP_ENV || 'unknown',
        release: window.APP_RELEASE || 'unknown',
        beforeSend : function(event) {
            // Named explicitly, because the event has not been sent yet and so
            // is not what Sentry would otherwise reach for as the last one
            if (event.exception) {
                Sentry.showReportDialog({eventId: event.event_id});
            }
            return event;
        }
    });
    
    // On js error, captuure exception / show dialogue
    window.onerror = function (msg, url, line, colNo, error) {
        if(error && error instanceof Error) {
            Sentry.captureException(error);
        } else {
            var msg = msg + " - " + url + ":" + line + ':' + colNo;
            console.log(msg);
        }
    }

    // If a server error is detected, open report dialogue
    let sentryErrorIdField = document.querySelector('input[name=sentry_error_id]');
    if(sentryErrorIdField) {
        Sentry.showReportDialog({
            eventId: sentryErrorIdField.value
        })
    }
}


// On document load
window.addEventListener('DOMContentLoaded', function() {
    // Base / utils
    BaseLayout.init();
    MenuSelector.init();

    // Blocks
    AccordionBlock.init();
    CarouselBannerBlock.init();

    // Modals
    GallleryLightbox.init();
});
